<div class="hierarchical-filters">
	<div class="scope-select-wrapper">
		<label class="scope-select-label">Select type</label>
		<kt-searchable-select
			[options]="typeOptions"
			[multiple]="false"
			[searchable]="false"
			[(ngModel)]="typeSelected"
			(selectionChange)="typeChanged($event)">
		</kt-searchable-select>
	</div>
	<div class="scope-select-wrapper">
		<label class="scope-select-label">Select mode</label>
		<kt-searchable-select
			[options]="modeOptions"
			[multiple]="false"
			[searchable]="false"
			[(ngModel)]="modeSelected"
			(selectionChange)="modeChanged($event)">
		</kt-searchable-select>
	</div>
</div>

<div class="mat-table__wrapper">

	<mat-table class="lmat-elevation-z8"
		#table
		[dataSource]="dataSource"
		matSort
		matSortActive="uploaded_at"
		matSortDirection="desc"
		matSortDisableClear>

		<ng-container matColumnDef="file_version">
			<mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
			<mat-cell *matCellDef="let file">
				{{file.file_version}}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="file_desc">
			<mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
			<mat-cell *matCellDef="let file">{{file.file_desc}}</mat-cell>
		</ng-container>



		<ng-container matColumnDef="file_name">
			<mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
			<mat-cell *matCellDef="let file">{{file.file_name}}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="uploaded_at">
			<mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded at</mat-header-cell>
			<mat-cell *matCellDef="let file">
				{{file.uploaded_at}}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="actions">
			<mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
			<mat-cell *matCellDef="let file">
				<button (click)="assign(file)" color="primary" mat-icon-button matTooltip="Assign">
					<mat-icon class="mat-danger-text">send</mat-icon>
				</button>&nbsp;
			</mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
	</mat-table>

	<div class="mat-table__message" *ngIf="(!modeSelected || !typeSelected)">Please Select File Type and Mode</div>
	<div class="mat-table__message" *ngIf="(dataSource.loading$ | async)">Please wait....</div>
	<div class="mat-table__message" *ngIf="dataSource.empty">No records found</div>
</div>

<div class="mat-table__bottom">
	<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
	<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
</div>
